import styled from 'styled-components';

export const Right = styled.div`
  position: absolute;
  right: 0;
  width: 10px;
  height: 100%;

  transform: translateX(50%);

  cursor: e-resize;
`;
